import { BiophysicsLegends } from '../BiophysicsLegends/BiophysicsLegends';
import { Box, Flex } from '@ttoss/ui';
import {
  DEFAULT_HINT_OPTIONS,
  DEFAULT_STEP_OPTIONS,
} from '../../constants/onboarding';
import { Hints, Steps } from 'intro.js-react';
import { LayerOption } from '../../providers/SiflorMapProvider/types';
import { useNavigation } from '../../providers/NavigationProvider/NavigationProvider';
import { useSiflorMap } from '../../providers/SiflorMapProvider/useSiflorMap';
import LayerCategory, {
  LayerCategoryProps,
} from '../LayerCategory/LayerCategory';
import MapButtons from '../MapButtons/MapButtons';
import MapWithSearch, {
  MapWithSearchProps,
} from '../MapWithSearch/MapWithSearch';
import React, { useState } from 'react';

export type BiophysicsProps = MapWithSearchProps;

export const ONBOARD_KEY = 'onboarding:Biophysics';

const Biophysics = (props: BiophysicsProps) => {
  const [filterOpened, setFilterOpened] = useState(false);
  const { isSiflorMapLoaded, getLayers, loadLayer, unloadLayer } =
    useSiflorMap();
  const [selectedLayer, setSelectedLayer] = useState<LayerOption>();
  const { popUpSpecialistWasClosed } = useNavigation();

  const layers = React.useMemo(() => {
    if (isSiflorMapLoaded) {
      return getLayers();
    }

    return [];
  }, [isSiflorMapLoaded, getLayers]);

  const handleApply: LayerCategoryProps['onApply'] = (layerSelected) => {
    if (selectedLayer) {
      unloadLayer(selectedLayer);
    }

    loadLayer(layerSelected);
    setFilterOpened(false);
    setSelectedLayer(layerSelected);
  };

  const [state, setState] = React.useState({
    stepsEnabled: false,
    initialStep: 0,
    steps: [
      {
        element: '.layers-button',
        intro:
          'Clique aqui para selecionar a característica que deve ser exibida',
      },
    ],
    hintsEnabled: true,
    hints: [
      {
        element: '.layers-button',
        hint: '',
        hintPosition: 'top-right',
      },
    ],
  });

  React.useEffect(() => {
    const showOnboarding = !localStorage.getItem(ONBOARD_KEY);

    if (popUpSpecialistWasClosed && showOnboarding) {
      setTimeout(() => {
        setState((prev) => {
          return { ...prev, stepsEnabled: true };
        });
      }, 1000);
    }
  }, [popUpSpecialistWasClosed]);

  const onExit = () => {
    setState((prev) => {
      return { ...prev, stepsEnabled: false };
    });
    localStorage.setItem(ONBOARD_KEY, 'showed');
  };

  return (
    <Flex sx={{ flexDirection: 'column', flex: 1, height: '100vh' }}>
      <MapWithSearch {...props} selectedSubMenu="biophysics">
        <MapButtons
          bottomLeft={{
            className: 'layers-button',
            icon: 'ic:outline-layers',
            onClick: () => {
              return setFilterOpened(true);
            },
            sx: {
              color: 'background',
              backgroundColor: 'secondary',
            },
          }}
        />

        <Steps
          enabled={state.stepsEnabled}
          steps={state.steps}
          initialStep={state.initialStep}
          onExit={onExit}
          options={DEFAULT_STEP_OPTIONS}
        />

        <Hints
          enabled={state.hintsEnabled}
          hints={state.hints}
          options={DEFAULT_HINT_OPTIONS}
        />

        {filterOpened && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              width: '100%',
              zIndex: 2,
              backgroundColor: 'background',
            }}
          >
            <LayerCategory
              layers={layers}
              onCancel={() => {
                return setFilterOpened(false);
              }}
              onApply={handleApply}
              initialLayer={selectedLayer}
            />
          </Box>
        )}
      </MapWithSearch>

      <BiophysicsLegends selectedLayer={selectedLayer} />
    </Flex>
  );
};

export default Biophysics;
